import React, { Component } from 'react'
import PropTypes from 'prop-types'
import FaqItem from './FaqItem'

class Faq extends Component {
  constructor (props) {
    super()
    this.state = {}
  }

  render () {
    const items = [
      {
        path: '/regulation',
        label: 'Regulamentos',
        icon: 'icon_file',
        order: 0
      },
      {
        path: '/terms',
        label: 'Termos de uso',
        icon: 'icon_file',
        order: 1
      },
      {
        path: '/privacy',
        label: 'Políticas de privacidade',
        icon: 'icon_file',
        order: 2
      }
    ]
    return (
      <li className='mx-1 p-0 h-100 item-menu-mobile border-top border-color-ui-1'>
        {items.map((item, index) =>
          <FaqItem key={index} callReset={this.props.callReset} activePage={this.props.activePage} text={item.label} icon={item.icon} path={item.path} />
        )}
      </li>
    )
  }
}

Faq.propTypes = {
  callReset: PropTypes.func.isRequired,
  activePage: PropTypes.func
}

export default Faq



// WEBPACK FOOTER //
// ./src/App/MainMenu/MenuMobile/Faq/Faq.js